import React from "react";
import { render } from "react-dom";
//import './index.css';
import App from "./App";

//import "bootstrap/dist/css/bootstrap.min.css";
//import "./main.css";
import { BrowserRouter } from "react-router-dom";
import FoodDeliveryPage from "./FoodDeliveryPage";
import Conta from "./FoodDeliveryPage/Conta";
import HubPedidos from "./HubPedidos";
//import Sidebar from './paginas/Sidebar';
//import Header from './paginas/Header';
render(
  <>

    <>
      {window.location.hostname === "fazpedido.com.br" || window.location.hostname === "www.fazpedido.com.br" ||
        window.location.hostname === "localhost" || window.location.hostname === "painel.octosoft.com.br" ||
        window.location.hostname === "192.168.1.71" ? (
        <App />
      ) : window.location.hostname === "fazpedido.app" || window.location.hostname === "daex.com" ? (
        <HubPedidos />
      ) : (
        <FoodDeliveryPage />
      )}
    </>



  </>,
  document.querySelector("#root")
);
